import request from 'client/utils/request'

export function getAgreement(pageId: number | string) {
  return request.get<string>(`/pages/${pageId}/user-agreement`)
}
